import {useEffect, useState} from 'react';

const getReturnValues = (countDown) => {
  const cd = Number.isFinite(countDown) ? Math.max(0, countDown) : 0;
  const days = Math.floor(cd / (1000 * 60 * 60 * 24));
  const hours = Math.floor((cd % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((cd % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((cd % (1000 * 60)) / 1000);
  return [days, hours, minutes, seconds];
};

const toMillis = (value) => {
  if (typeof value === 'number') return value;
  if (value instanceof Date) return value.getTime();
  // Luxon DateTime support
  if (value && typeof value.toMillis === 'function') {
    return value.toMillis();
  }
  if (typeof value === 'string') {
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? NaN : parsed;
  }
  return NaN;
};
const useCountdown = (targetDate) => {
  const countDownDate = toMillis(targetDate);
  const [countDown, setCountDown] = useState(() => {
    const delta = countDownDate - Date.now();
    return Number.isFinite(delta) ? Math.max(0, delta) : 0;
  });
  useEffect(() => {
    if (!Number.isFinite(countDownDate)) {
      setCountDown(0);
      return;
    }
    const interval = setInterval(() => {
      const delta = countDownDate - Date.now();
      if (delta <= 0) {
        setCountDown(0);
        clearInterval(interval);
      } else {
        setCountDown(delta);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [countDownDate]);
  return getReturnValues(countDown);
};

export {useCountdown};
